import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
http.interceptors.response.use(undefined, async (error) => {
  const cfg = error.config;
  if (error.response?.status === 401 && !cfg._retry && !cfg.url.startsWith("/auth/")) {
    cfg._retry = true;
    refreshing = refreshing || http.post("/auth/refresh").finally(() => (refreshing = null));
    await refreshing;
    return http(cfg);
  }
  throw error;
});

export const formatApiError = (detail) => {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
};

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    http.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => http.post("/auth/refresh").then((r) => setUser(r.data)).catch(() => setUser(false)));
  }, []);
  const login = async (email, password) => setUser((await http.post("/auth/login", { email, password })).data);
  const logout = async () => {
    await http.post("/auth/logout");
    setUser(false);
  };
  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
